// --------------------------------------------------------------
// Created On: 2026-11-02
// Author: Zachary Thomas
//
// Last Modified: 2026-11-02
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import {
  CUSTOMER_SERVICE_EMAIL,
  CUSTOMER_SERVICE_OVERRIDE_MESSAGE,
  CUSTOMER_SERVICE_PHONE,
} from "src/constants/miscellaneous";

// Gets the customer service message to send to the user in the event an error occurs.
export default function getCustomerServiceMessage(): string {
  if (CUSTOMER_SERVICE_OVERRIDE_MESSAGE === null) {
    return (
      `If you believe this is an error, please contact customer service at ${CUSTOMER_SERVICE_EMAIL} ` +
      `or by phone at ${CUSTOMER_SERVICE_PHONE}.`
    );
  } else {
    return `If you believe this is an error, ${CUSTOMER_SERVICE_OVERRIDE_MESSAGE}`;
  }
}
